import Table from "../components/Table";
import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useRef, useState } from "react";
import $ from "jquery";
import config from "../../../config";
import Pagination from "../../../components/Pagination";
import filterIcon from "../../../images/icons/filter.png";
import "../style.css";
import Swal from "sweetalert2";
import moment from "moment";
import Tippy from "@tippyjs/react";
import Filter from "../components/Filter";
import ExcelDownload from "../components/ExcelDownload";
import { millionComma } from "../../../utils";

const PurchaseMovement = (props) => {
  const [user, setUser] = useState({});
  const [pageSize, setPageSize] = useState(10);

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const getBranchList = async (inputValue, callback) => {
    let branches = props.branchList.filter((b) =>
      b.label
        .toString()
        .toLowerCase()
        .includes(inputValue.toString().toLowerCase())
    );
    callback(branches);
  };

  const getLedgerList = async (inputValue, callback) => {
    let paymentMode = config.paymentMode.filter((b) =>
      b.label
        .toString()
        .toLowerCase()
        .includes(inputValue.toString().toLowerCase())
    );
    callback(paymentMode);
  };
  const getStatusList = config.filterPurchaseStatus;

  const isMounted = useRef(false);

  const filterList = [
    {
      name: "branch_id",
      label: "Branch Name",
      type: "async_select",
      required: false,
      visible: [1, 2].includes(user.role_id),
      values: getBranchList,
    },
    {
      name: "payment_mode_id",
      label: "Payment Mode",
      type: "async_select",
      values: getLedgerList,
    },
    {
      name: "status",
      label: "Status",
      type: "select-dropdown",
      values: getStatusList,
    },
    { name: "from_date", label: "From Date", type: "date", required: true },
    { name: "to_date", label: "To Date", type: "date", required: true },
  ];

  const columnList = [
    { label: "PO No", value: "po_no", visible: true },
    { label: "Buyer Name", value: "buyer_name", visible: true },
    { label: "Date", value: "po_date", visible: true },
    { label: "Amount", value: "amount", visible: true },
    { label: "Return Amt", value: "return_amt", visible: true },
    { label: "Final Amt", value: "final_amt", visible: true },
    {
      label: "Branch Name",
      value: "branch_name",
      visible: [1, 2].includes(user.role_id),
    },
    { label: "Payment Mode", value: "payment_mode_id", visible: true },
    { label: "Status", value: "status", visible: true },
  ];

  const [filter, setFilter] = useState(() => {
    let filters = {};
    filterList.forEach((list) => {
      if (list.name === "from_date" || list.name === "to_date") {
        filters[list.name] = moment().format("YYYY-MM-DD");
      } else {
        filters[list.name] = "";
      }
    });
    return filters;
  });
  const [column, setColumn] = useState(() => columnList);
  useEffect(() => {
    setColumn(() => columnList);
    setFilter(() => {
      let filters = {};
      filterList.forEach((list) => {
        if (list.name === "from_date" || list.name === "to_date") {
          filters[list.name] = moment().format("YYYY-MM-DD");
        } else {
          filters[list.name] = "";
        }
      });
      return filters;
    });
  }, [user]);
  const [row, setRow] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [showFilter, setShowFilter] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const [totalAmt, setTotalAmt] = useState(0);
  const [totalAmtPerPage, setTotalAmtPerPage] = useState(0);
  const getList = async () => {
    if (!filter?.from_date || !filter?.to_date) {
      Swal.fire("Error", "Date is Required");
      return;
    }

    if (user?.role_id === 3 || user?.role_id === 4) {
      filter.branch_id = JSON.parse(
        localStorage.getItem("inventory")
      )?.userData?.branch_data?.[0]?.branch_id;
    }

    setShowLoading(true);
    await $.post(
      `${config.apiUrl}/report/listPurchaseMovement`,
      JSON.stringify({
        ...filter,
        paginate: 1,
        page_no: currentPage - 1,
        page_size: pageSize,
      })
    )
      .done((res) => {
        if (res?.data?.list?.length > 0) {
          let cols = columnList.map((col) => col.value);
          let total = res?.data?.totalAmount || 0;
          let totalPerPage = res?.data?.totalAmountPerPage || 0;
          setRow(() => {
            let resArr = res?.data?.list || [];
            let arr = [];
            resArr.forEach((r, i) => {
              let paymentMode =
                config?.paymentMode?.find(
                  (p) => p?.value === r?.payment_mode_id
                )?.label || "";
              arr.push({
                po_id: r?.po_id || "",
                po_no: r?.po_no || "",
                buyer_name: r?.buyer_name || "",
                po_date: moment(r?.po_date)?.format("DD-MM-YYYY") || "",
                amount: millionComma(r?.amount || 0),
                return_amt: millionComma(r?.return_amt || 0),
                final_amt: millionComma(r?.final_amt || 0),

                branch_name: r?.branch_name || "",
                payment_mode_id: paymentMode,
                status: r.status || "",
              });
            });
            return arr;
          });
          setTotalPage(() => res?.data?.count || 0);
          setCurrentPage(() => currentPage);
          setTotalAmt(total);
          setTotalAmtPerPage(totalPerPage);
        } else {
          setTotalPage(() => 0);
          setCurrentPage(() => 1);
          setRow(() => []);
          setTotalAmt(0);
          setTotalAmtPerPage(0);
        }
        setShowLoading(false);
      })
      .fail((err) => {
        Swal.fire(
          "",
          err?.responseJSON?.data?.message || err?.responseJSON?.message
        );
        setShowLoading(false);
      });
  };

  const clearList = () => {
    setFilter(() => {
      let filters = {};
      filterList.forEach((list) => {
        filters[list.name] = "";
      });
      return filters;
    });
    setTotalPage(() => 0);
    setCurrentPage(() => 1);
    setRow(() => []);
  };

  useEffect(() => {
    if (isMounted.current) getList();
    isMounted.current = true;
  }, [currentPage]);
  const changePageSize = (e) => {
    const newSize = e.target.value;
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (row.length > 0) {
      getList();
    }
  }, [pageSize]);
  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />
          <main className="bg-white rounded-2" id="ledger">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col-md">
                  <Breadcrumb path={["Purchases"]} />
                </div>

                <div className="col-md text-end">
                  <select value={pageSize} onChange={(e) => changePageSize(e)}>
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <Tippy content="Filter" trigger="mouseenter">
                    <img
                      src={filterIcon}
                      className="img-fluid mx-2 icon"
                      width="35px"
                      height="35px"
                      alt=""
                      role="button"
                      onClick={(e) => setShowFilter(!showFilter)}
                    />
                  </Tippy>

                  <ExcelDownload
                    filter={filter}
                    filename="Purchases"
                    url={`${config.apiUrl}/report/listPurchaseMovement`}
                  />
                </div>
              </div>

              <Filter
                show={showFilter}
                filterList={filterList}
                showLoading={showLoading}
                handler={{ getList, clearList, state: { filter, setFilter } }}
              />

              <Table tableData={{ column, row }} handler={{ getList }} />
              {row.length > 0 && (
                <div className="d-flex justify-content-end align-items-center">
                  <span className="fw-semibold " style={{ fontSize: "18px" }}>
                    Page Wise Total Amount :&nbsp;
                    <span className="">{millionComma(totalAmtPerPage)}</span>
                  </span>
                </div>
              )}
              {row.length > 0 && (
                <div className="d-flex justify-content-end align-items-center">
                  <span className="fw-semibold " style={{ fontSize: "20px" }}>
                    Overall Total Amount:&nbsp;
                    <span className="">{millionComma(totalAmt)}</span>
                  </span>
                </div>
              )}
              <div className="row mt-4">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / Number(pageSize))}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default PurchaseMovement;
